import {
  ScaffoldCards,
  Section,
  SectionHeader,
  Text,
} from '@inmotionnow/momentum-components-react'
import * as React from 'react'

import { type AccountUser } from '@/features/accounts/accountApi'

import { MemberCard } from './member-card'

export interface IAccountMembersListProps {
  title: string
  members: AccountUser[]
  emptyMessage: string
  accountId?: number
}

const AccountMembersList: React.FunctionComponent<IAccountMembersListProps> = ({
  title,
  members,
  emptyMessage,
  accountId,
}) => (
  <Section padding={['none', 'none', 'lg', 'none']}>
    <SectionHeader title={title} colorize />
    <Section padding={['lg', 'none', 'none', 'none']}>
      {members.length ? (
        <ScaffoldCards>
          {members.map(accountUser => (
            <MemberCard
              key={accountUser.id}
              member={accountUser}
              accountId={accountId}
            />
          ))}
        </ScaffoldCards>
      ) : (
        <Text>{emptyMessage}</Text>
      )}
    </Section>
  </Section>
)

export { AccountMembersList }
